import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PaperBG } from "../kits/DesignKit";
import { logoPath } from "../config";

const Preloader = ({ children, isReady }) => {
  const [hasExited, setHasExited] = useState(false);

  return (
    <>
      <AnimatePresence onExitComplete={() => setHasExited(true)}>
        {!isReady && (
          <motion.div
            key="preloader"
            initial={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            exit={{ opacity: 0, scale: 1.1, filter: "blur(4px)" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="fixed inset-0 z-50"
          >
            <PaperBG fullHeight className="flex items-center justify-center">
              <div className="relative w-14 h-14 flex items-center justify-center">
                {[...Array(2)].map((_, i) => (
                  <motion.div
                    key={i}
                    className="absolute rounded-full border border-brand"
                    style={{ width: "100%", height: "100%" }}
                    initial={{ scale: 0.8, opacity: 0.4 }}
                    animate={{ scale: 1.6, opacity: 0 }}
                    transition={{ duration: 2.5, repeat: Infinity, delay: i * 0.5 }}
                  />
                ))}
                <div className="z-50 relative 
                w-14 h-14 
                bg-gra-50 border border-gray-200 shadow-md rounded-full flex items-center justify-center">
                  <img
                    src={logoPath}
                    alt="Logo Bitter. Lern Einfach Auhtentisch"
                    className="w-12 h-12 border rounded-full border-brand/60"
                  />
                </div>
              </div>

              <div className="absolute bottom-24 text-center text-sm font-mono text-brand">
               Moin aus Hamburg<br/> Gleich geht&apos;s los
              </div>
            </PaperBG>
          </motion.div>
        )}
      </AnimatePresence>

      {hasExited && <>{children}</>}
    </>
  );
};

export default Preloader;
